export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/french.1f7bd0b.svg";